import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from 'gridjs-react';
import { html } from 'gridjs';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Modal, ModalBody, Button } from '../../../Components/ui';
import { getFields, getDataList } from '../../../common/utils/extraction';
import { API, BACKEND_HOST } from '../../../api';
import UsageSection from '../../../Components/B2Busage';
import { dialogService } from "@/utils/dialogService";
export default function VoucherList() {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [fields, setFields] = React.useState([]);
    const [delRecord, setDelRecord] = React.useState<number | null>(null);
    const [modalDelete, setModalDelete] = React.useState(false);
    function tog_delete() {
        setModalDelete(!modalDelete);
    }
    const handleEdit = useCallback((id: number) => {
        navigate(`/voucher-form/${id}`);
    }, [navigate]);
    const handleManageDistribution = useCallback((id: number) => {
        navigate(`/voucher-form/${id}?tab=book`);
    }, [navigate]);
    const handleCopy = useCallback((id: number) => {
        navigate(`/voucher-form/${id}?copy=true`);
    }, [navigate]);
    const handleDelete = useCallback((id: number) => {
        setDelRecord(id);
        tog_delete();
    }, []);
    // Event listeners for gridjs button clicks (since html() doesn't support React onClick)
    useEffect(() => {
        const handleEditEvent = (e: CustomEvent) => {
            handleEdit(e.detail);
        };
        const handleDistributionEvent = (e: CustomEvent) => {
            handleManageDistribution(e.detail);
        };
        const handleCopyEvent = (e: CustomEvent) => {
            handleCopy(e.detail);
        };
        const handleDeleteEvent = (e: CustomEvent) => {
            handleDelete(e.detail);
        };
        window.addEventListener('editVoucher', handleEditEvent as EventListener);
        window.addEventListener('manageVoucherDistribution', handleDistributionEvent as EventListener);
        window.addEventListener('copyVoucher', handleCopyEvent as EventListener);
        window.addEventListener('deleteVoucher', handleDeleteEvent as EventListener);
        return () => {
            window.removeEventListener('editVoucher', handleEditEvent as EventListener);
            window.removeEventListener('manageVoucherDistribution', handleDistributionEvent as EventListener);
            window.removeEventListener('copyVoucher', handleCopyEvent as EventListener);
            window.removeEventListener('deleteVoucher', handleDeleteEvent as EventListener);
        };
    }, [handleManageDistribution, handleEdit, handleCopy, handleDelete]);
    React.useEffect(() => {
        API.get(`${BACKEND_HOST}/voucher/?include_retired=true`)
            .then(({ data }) => {
            const fieldName = Object.keys(data[0]);
            const _customFeildNames = {
                "id": "id",
                "이름": "이름",
                "만료일": "만료일",
                "giftable": "선물가능여부",
            };
            let tmpFields = getFields(fieldName);
            tmpFields = tmpFields.map((field) => {
                if (field.name in _customFeildNames) {
                    field.accessor = field.name;
                    field.id = field.name;
                    field.name = _customFeildNames[field.name];
                    field.sortable = false;
                }
                return field;
            });
            tmpFields.push({
                name: 'Actions',
                width: '200px',
                formatter: (cell: any) => {
                    const safeId = Number(cell);
                    if (!Number.isFinite(safeId)) {
                        return html('');
                    }
                    return html(`<div class="d-flex gap-2">
                            <div class="distribution">
                                <button class="btn btn-sm btn-primary" onclick="window.dispatchEvent(new CustomEvent('manageVoucherDistribution', {detail: ${safeId}}))">배포설정</button>
                            </div>
							<div class="edit">
								<button class="btn btn-sm btn-success edit-item-btn" onclick="window.dispatchEvent(new CustomEvent('editVoucher', {detail: ${safeId}}))">수정</button>
							</div>
							<div class="copy">
								<button class="btn btn-sm btn-info copy-item-btn" onclick="window.dispatchEvent(new CustomEvent('copyVoucher', {detail: ${safeId}}))">복사</button>
							</div>
							<div class="remove">
								<button class="btn btn-sm btn-danger remove-item-btn" onclick="window.dispatchEvent(new CustomEvent('deleteVoucher', {detail: ${safeId}}))">삭제</button>
							</div>
						</div>`);
                }
            });
            setFields(tmpFields);
            let dataArr = getDataList(data);
            setData(dataArr);
        })
            .catch(e => console.log(e));
    }, []);
    const deleteRecord = () => {
        API.delete(`${BACKEND_HOST}/voucher/${delRecord}/`)
            .then(async (data) => { await dialogService.handleAlert("Delete ok!"); window.location.reload(); })
            .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
    };
    return (<React.Fragment>
			<div className="page-content">
				<div className="container-fluid">
					<BreadCrumb title="교환권목록" pageTitle="교환권"/>
					<div className="flex flex-wrap -mx-3">
						<div className="w-full px-3">
							<div className="card">
								<div className="card-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
									<h4 className="card-title mb-0 flex-grow-1">교환권 목록</h4>
									<div>
										<Button onClick={() => { navigate(`/voucher-form/${0}`); }} id="create-btn" color="success" className="add-btn me-1"><i className="ri-add-line align-bottom me-1"></i> 생성</Button>
									</div>
								</div>

								<div className="card-body">
									<UsageSection productType="voucher"/>

									<div id="table-gridjs">
										<Grid data={data} columns={fields}/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Modal isOpen={modalDelete} onClose={() => setModalDelete(false)}>
				<ModalBody className="text-center p-5">
					<div className="mt-4">
						<h4 className="mb-3">Are you Sure ?</h4>
						<p className="text-muted mb-4">{`Are you Sure You want to Remove this Record(id:${delRecord}) ?`}</p>
						<div className="hstack gap-2 justify-content-center">
							<Button onClick={() => { setDelRecord(null); setModalDelete(false); }} color="light">Cancel</Button>
							<Button onClick={deleteRecord} color="danger">Delete</Button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</React.Fragment>);
}
